<!-- @format -->

<template>
	<div :class="isHeight ? 'workOrder workOrderHeightMax' : 'workOrder'">
		<div class="work-img-border workOrderAll">
			<div class="workOrderTop">
				<el-row>
					<el-col :span="20">
						<span>
							<span class="more-title" @click="goTOWork">
								工作事项
								<el-icon style="font-size: 14px">
									<ArrowRightBold />
								</el-icon>
							</span>
							<span v-if="!isWorkbenchedit" class="arrowIconName"></span>
						</span>
					</el-col>
					<el-col class="setting" :span="4">
						<el-icon v-if="isWorkbenchedit" style="margin-right: 10px" @click="settingIcon">
							<icon-ant-design:setting-outlined />
						</el-icon>
						<el-icon v-if="isWorkbenchedit" @click="delEdit"><icon-ant-design:delete-outlined /></el-icon>
					</el-col>
				</el-row>
			</div>

			<div class="workOrderTable">
				<el-tabs v-if="isTable" v-model="activeName" class="demo-tabs" @tab-click="handleClick">
					<el-tab-pane
						v-for="item in selectedTabList"
						:key="item.code"
						:label="`${item.name}(${tabTotals[item.code] || 0})`"
						:name="item.code"
					>
						<el-table
							ref="workOrderList"
							v-loading="loading"
							:data="toWorkList"
							style="width: 100%"
							:height="isHeight ? '100%' : '230px'"
							border
							@row-click="tableClick"
						>
							<el-table-column type="index" width="50" label="序号" />
							<el-table-column prop="baseSummary" label="工单标题" :show-overflow-tooltip="true" align="left">
								<template #default="scope">
									<div class="workType-box">
										<span v-if="scope.row.slaStatus == null" class="workType-icon"></span>
										<span class="workType" style="text-align: left">
											<el-tooltip placement="top">
												<template #content>
													{{ workorderCountdown(scope.row) }}
													<span v-if="scope.row.slaStatus == 1" class="countDownBox">
														协议时间为：{{ scope.row.slaTargetTime }}，距离协议时间还有：
														<count-down
															:end-time="getSLAtime(scope.row.slaTargetTime)"
															end-text="已经结束了"
															@istime-over="istimeOver(scope.row)"
														/>
													</span>
												</template>
												<span
													v-if="scope.row.slaStatus !== null && scope.row.slaStatus == 1"
													class="slaBox"
													style="border: 3px solid #1a9bff"
												></span>
												<span
													v-else-if="scope.row.slaStatus !== null && scope.row.slaStatus == 0"
													class="slaBox"
													style="border: 3px solid #1aad19"
												></span>
												<span
													v-else-if="scope.row.slaStatus !== null && scope.row.slaStatus == 2"
													class="slaBox"
													style="border: 3px solid #ff1e10"
												></span>
											</el-tooltip>
										</span>

										<span class="baseSummary">
											{{ scope.row.baseSummary }}
										</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column
								align="left"
								prop="ticketNum"
								class="baseSummary"
								width="300"
								label="流水号"
								:show-overflow-tooltip="true"
							/>
							<el-table-column
								width="300"
								prop="modelName"
								label="工单类型"
								align="left"
								:show-overflow-tooltip="true"
							/>
							<el-table-column prop="ticketStatus" label="当前阶段" align="left" :show-overflow-tooltip="true" />
							<el-table-column
								prop="creatorName"
								label="申请人"
								width="140"
								align="left"
								:show-overflow-tooltip="true"
							/>
							<el-table-column
								align="left"
								prop="createDate"
								label="申请时间"
								:show-overflow-tooltip="true"
								width="200"
							/>
						</el-table>
					</el-tab-pane>
					<el-pagination
						v-model:current-page="pageValue.pageNum"
						v-model:page-size="pageValue.pageSize"
						class="workOrderPagination"
						:page-sizes="[10, 20, 30, 40]"
						:disabled="disabled"
						:background="background"
						layout="total, sizes, prev, pager, next"
						:total="tabTotals[activeName] || 0"
						@size-change="onChangeSize"
						@current-change="onChangeNum"
					/>
				</el-tabs>
				<el-tabs v-else v-model="activeName" class="demo-tabs" @tab-click="handleClick">
					<el-tab-pane
						v-for="item in selectedTabList"
						:key="item.code"
						:label="`${item.name}(${tabTotals[item.code] || 0})`"
						:name="item.code"
					>
						<el-table
							ref="workOrderList"
							v-loading="loading"
							:data="toWorkList"
							style="width: 100%"
							:height="isHeight ? '100%' : '230px'"
							border
							@row-click="tableClick"
						>
							<el-table-column type="index" width="50" label="序号" />
							<el-table-column prop="baseSummary" label="工单标题" :show-overflow-tooltip="true">
								<template #default="scope">
									<div class="workType-box">
										<span v-if="scope.row.slaStatus == null" class="workType-icon"></span>
										<span class="workType">
											<el-tooltip placement="top">
												<template #content>
													{{ workorderCountdown(scope.row) }}
													<span v-if="scope.row.slaStatus == 1" class="countDownBox">
														协议时间为：{{ scope.row.slaTargetTime }}，距离协议时间还有：
														<count-down
															:end-time="getSLAtime(scope.row.slaTargetTime)"
															end-text="已经结束了"
															@istime-over="istimeOver(scope.row)"
														/>
													</span>
												</template>
												<span
													v-if="scope.row.slaStatus !== null && scope.row.slaStatus == 1"
													class="slaBox"
													style="border: 3px solid #1a9bff"
												></span>
												<span
													v-else-if="scope.row.slaStatus !== null && scope.row.slaStatus == 0"
													class="slaBox"
													style="border: 3px solid #1aad19"
												></span>
												<span
													v-else-if="scope.row.slaStatus !== null && scope.row.slaStatus == 2"
													class="slaBox"
													style="border: 3px solid #ff1e10"
												></span>
											</el-tooltip>
										</span>

										<span class="baseSummary">
											{{ scope.row.baseSummary }}
										</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="300"
								prop="ticketNum"
								class="baseSummary"
								label="流水号"
								:show-overflow-tooltip="true"
							/>
							<el-table-column
								prop="modelName"
								align="left"
								label="工单类型"
								width="300"
								:show-overflow-tooltip="true"
							/>
							<el-table-column
								v-if="activeName !== 'caogaoxiang'"
								prop="ticketStatus"
								align="left"
								label="当前阶段"
								:show-overflow-tooltip="true"
							/>
							<el-table-column
								v-if="activeName !== 'caogaoxiang' && activeName !== 'faqi'"
								prop="creatorName"
								align="left"
								label="建单人"
								width="140"
								:show-overflow-tooltip="true"
							/>
							<el-table-column
								prop="createDate"
								width="200"
								align="left"
								label="创建时间"
								:show-overflow-tooltip="true"
							/>
						</el-table>
					</el-tab-pane>
				</el-tabs>
				<el-pagination
					v-model:current-page="pageValue.pageNum"
					v-model:page-size="pageValue.pageSize"
					class="workOrderPagination"
					:page-sizes="[10, 20, 30, 40]"
					:disabled="disabled"
					:background="background"
					layout="total, sizes, prev, pager, next"
					:total="tabTotals[activeName] || 0"
					@size-change="onChangeSize"
					@current-change="onChangeNum"
				/>
			</div>
		</div>
	</div>
	<!-- 对话框 -->
	<el-dialog
		v-model="dialogVisible"
		:close-on-click-modal="false"
		append-to-body
		title="工单列表"
		width="50%"
		:before-close="dialogCancel"
		custom-class="workOrderDialog"
	>
		<el-transfer
			v-model="transferValue"
			:titles="['未选择类型', '已选择类型']"
			target-order="push"
			:data="transferData"
			@change="transferChange"
		>
		</el-transfer>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="dialogCancel">取消</el-button>
				<el-button type="primary" @click="dialogDetermine">确定</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script setup name="workOrder">
	import { ref } from 'vue';
	import { ElMessage } from 'element-plus';
	import { onBeforeRouteLeave } from 'vue-router';
	import { useGlobalStoreWithOut, getEnvUrlByUrl } from '@power/runtime-vue3';
	import { openWindow } from '@power/utils';
	import {
		userTodo,
		userProcessed,
		userCreated,
		workflowTypes,
		listModelName,
		openTicketInfo,
		getProcessedDraft,
	} from '@/api/powercess/workbench';

	// import countDown from '@/components/CountDown';

	const globalStore = useGlobalStoreWithOut();

	const emit = defineEmits(['deletePanelItemEvent', 'selectItemEvent']);
	const props = defineProps({
		isHeight: {
			type: [Boolean],
		},
		isWorkbenchedit: {
			type: [Boolean],
		},
		id: {
			type: [Number, String],
		},
		editArray: {
			type: [Array],
		},
	});

	const pageValue = ref({
		pageNum: 1,
		pageSize: 20,
	});

	const tabTotals = ref({});

	const activeName = ref('daiban');

	const workTypeList = ref([
		{
			name: '工单待办',
			code: 'daiban',
			disabled: false,
		},
		{
			name: '工单已办',
			code: 'yiban',
			disabled: false,
		},
		{
			name: '我发起的',
			code: 'faqi',
			disabled: false,
		},
		{
			name: '全部工单',
			code: 'quanbu',
			disabled: false,
		},
		{
			name: '草稿箱',
			code: 'caogaoxiang',
			disabled: false,
		},
	]);

	// 表格是否加载
	const loading = ref(true);

	const isTable = ref(false);

	// 工单数据
	const toWorkList = ref([]);

	// 已选表头页
	const selectedTabList = ref([]);

	// 控制模态框显隐
	const dialogVisible = ref(false);
	// 穿梭框的数据
	const transferData = ref(generateData());

	const totalsLoaded = ref(false);
	// 穿梭框中选中的值
	const transferValue = ref(props.editArray && props.editArray.length ? props.editArray : []);
	// 点击修改标签页的标识
	const modelName = ref('');

	function getSLAtime(time) {
		return `${new Date(time).getTime() / 1000} `;
	}

	function delEdit() {
		emit('deletePanelItemEvent', props.id);
	}

	function settingIcon() {
		dialogVisible.value = true;
		isTable.value = false;
	}

	// 倒计时结束时标识改变
	function istimeOver(row) {
		row.slaStatus = 2;
	}

	// 个人待办工单查询
	function personalToDo(type) {
		loading.value = true;
		if (type === 'handleClick') {
			selectedTabsMethod(type);
		} else {
			selectedTabsMethod();
		}

		interfaceSummary();
	}

	// 数据接口汇总
	function interfaceSummary() {
		loading.value = true;
		if (activeName.value === 'daiban') {
			userTodo({
				pageNo: pageValue.value.pageNum,
				pageSize: pageValue.value.pageSize,
			}).then((res) => {
				loading.value = false;
				toWorkList.value = res.rows;
				tabTotals.value[activeName.value] = res.total;
			});
		} else if (activeName.value === 'yiban') {
			userProcessed({
				pageNo: pageValue.value.pageNum,
				pageSize: pageValue.value.pageSize,
			}).then((res) => {
				loading.value = false;
				toWorkList.value = res.rows;
				tabTotals.value[activeName.value] = res.total;
			});
		} else if (activeName.value === 'faqi') {
			userCreated({
				pageNo: pageValue.value.pageNum,
				pageSize: pageValue.value.pageSize,
			}).then((res) => {
				loading.value = false;
				toWorkList.value = res.rows;
				tabTotals.value[activeName.value] = res.total;
			});
		} else if (activeName.value === 'quanbu') {
			listModelName({
				pageNo: pageValue.value.pageNum,
				pageSize: pageValue.value.pageSize,
			}).then((res) => {
				loading.value = false;
				toWorkList.value = res.rows;
				tabTotals.value[activeName.value] = res.total;
			});
		} else if (activeName.value === 'caogaoxiang') {
			getProcessedDraft({
				pageNo: pageValue.value.pageNum,
				pageSize: pageValue.value.pageSize,
			}).then((res) => {
				loading.value = false;
				toWorkList.value = res.rows;
				tabTotals.value[activeName.value] = res.total;
			});
		} else {
			listModelName({
				pageNo: pageValue.value.pageNum,
				pageSize: pageValue.value.pageSize,
				modelName: modelName.value,
			}).then((res) => {
				loading.value = false;
				toWorkList.value = res.rows;
				tabTotals.value[activeName.value] = res.total;
			});
		}
	}

	function loadTabTotal(code) {
		return new Promise((resolve) => {
			if (code === 'daiban') {
				userTodo({ pageNo: 1, pageSize: 20 })
					.then((res) => {
						tabTotals.value[code] = res.total;
						resolve();
					})
					.catch(() => resolve());
			} else if (code === 'yiban') {
				userProcessed({ pageNo: 1, pageSize: 20 })
					.then((res) => {
						tabTotals.value[code] = res.total;
						resolve();
					})
					.catch(() => resolve());
			} else if (code === 'faqi') {
				userCreated({ pageNo: 1, pageSize: 20 })
					.then((res) => {
						tabTotals.value[code] = res.total;
						resolve();
					})
					.catch(() => resolve());
			} else if (code === 'quanbu') {
				listModelName({ pageNo: 1, pageSize: 20 })
					.then((res) => {
						tabTotals.value[code] = res.total;
						resolve();
					})
					.catch(() => resolve());
			} else if (code === 'caogaoxiang') {
				getProcessedDraft({ pageNo: 1, pageSize: 20 })
					.then((res) => {
						tabTotals.value[code] = res.total;
						resolve();
					})
					.catch(() => resolve());
			} else {
				listModelName({
					pageNo: 1,
					pageSize: 20,
					modelName: code,
				})
					.then((res) => {
						tabTotals.value[code] = res.total;
						resolve();
					})
					.catch(() => resolve());
			}
		});
	}

	const onChangeSize = (val) => {
		pageValue.value.pageSize = val;
		interfaceSummary();
	};

	const onChangeNum = (val) => {
		pageValue.value.pageNum = val;
		interfaceSummary();
	};

	// 点击表格的一行
	function tableClick(row) {
		if (!props.isWorkbenchedit) {
			const { ticketId, modelCode, taskId } = row;
			openTicketInfo({
				ticketId,
				modelCode,
				taskId,
			}).then((res) => {
				const url = getEnvUrlByUrl(res.data);
				openWindow(url);
			});
		}
	}

	// 获得所有工单类型
	function getWorkflowType() {
		workflowTypes({ permissionType: 'QUERY' }).then((res) => {
			const data = res.data.map((item) => ({
				...item,
				disabled: false,
			}));
			workTypeList.value = workTypeList.value.concat(data);
			transferData.value = generateData();
			selectedTabsMethod();
			loadAllSelectedTabTotals();
		});
	}

	// 根据已选表头渲染数据
	function selectedTabsMethod(type) {
		const workTypes = workTypeList.value;
		const transfer = transferValue.value;

		const selectedTabs = [];
		for (let i = 0; i < transfer.length; i++) {
			for (let j = 0; j < workTypes.length; j++) {
				if (transfer[i] === workTypes[j].code) {
					selectedTabs.push(workTypes[j]);
				}
			}
		}
		selectedTabList.value = selectedTabs;
		if (type !== 'handleClick') {
			isTable.value = !isTable.value;
		}
	}

	// 切换标签页触发
	function handleClick(tab) {
		activeName.value = tab.props.name;
		modelName.value = tab.props.label;
		pageValue.value = {
			pageNum: 1,
			pageSize: 20,
		};
		personalToDo('handleClick');
	}

	// 渲染要展示穿梭框的数据
	function generateData() {
		const data = [];
		for (let i = 0; i < workTypeList.value.length; i++) {
			data.push({
				key: workTypeList.value[i].code,
				label: workTypeList.value[i].name,
				disabled: workTypeList.value[i].disabled,
			});
		}
		return data;
	}

	// 穿梭框数据的变化
	function transferChange(rightList, direction, moveData) {
		if (direction === 'right') {
			if (rightList.length > 16) {
				const oldTransferValue = [];
				rightList.forEach((res) => {
					const index = moveData.indexOf(res);
					if (index == -1) {
						oldTransferValue.push(res);
					}
				});
				transferValue.value = oldTransferValue;
				ElMessage({
					message: '请最多选择16个！',
					type: 'warning',
				});
			} else {
				transferValue.value = rightList;
			}
			loadAllSelectedTabTotals();
		} else {
			transferValue.value = rightList;
		}
	}

	// 对话框确定按钮
	function dialogDetermine() {
		const selectItemEvent = {
			selectList: transferValue.value,
			// module: '工作事项',
			module: props.id,
		};
		emit('selectItemEvent', selectItemEvent);
		dialogVisible.value = false;
		activeName.value = 'daiban';
		personalToDo();
		loadAllSelectedTabTotals();
	}

	// 对话框取消按钮
	function dialogCancel() {
		dialogVisible.value = false;
		isTable.value = true;
		transferValue.value = selectedTabList.value.map((item) => item.code);
	}

	// 点击更多跳往工单页面
	function goTOWork() {
		let hidden = 'hidePcLayoutMenu=1';
		globalStore.subSystems.map((item) => {
			if (item.alias === 'powerprocess') {
				hidden = '';
			}
		});
		if (!props.isWorkbenchedit) {
			if (activeName.value === 'daiban') {
				let url = `powerprocess/order/todo${hidden !== '' ? `?${hidden}` : ''}`;
				url = getEnvUrlByUrl(url);
				openWindow(url);
			} else if (activeName.value === 'yiban') {
				let url = `powerprocess/order/processed${hidden !== '' ? `?${hidden}` : ''}`;
				url = getEnvUrlByUrl(url);
				openWindow(url);
			} else if (activeName.value === 'faqi') {
				let url = `powerprocess/order/created${hidden !== '' ? `?${hidden}` : ''}`;
				url = getEnvUrlByUrl(url);
				openWindow(url);
			} else if (activeName.value === 'quanbu') {
				let url = `powerprocess/order/All${hidden !== '' ? `?${hidden}` : ''}`;
				url = getEnvUrlByUrl(url);
				openWindow(url);
			} else if (activeName.value === 'caogaoxiang') {
				let url = `powerprocess/order/drafts${hidden !== '' ? `?${hidden}` : ''}`;
				url = getEnvUrlByUrl(url);
				openWindow(url);
			} else {
				let url = `powerprocess/order/All?workTypeName=${activeName.value}${hidden !== '' ? `&${hidden}` : ''}`;
				url = getEnvUrlByUrl(url);
				openWindow(url);
			}
		}
	}

	function workorderCountdown(row) {
		const state = row.slaStatus;
		if (state !== null && state == 0) {
			return '未逾期，已结束';
		} else if (state !== null && state == 1) {
			return '进行中';
		} else if (state !== null && state == 2) {
			return '已逾期';
		}
	}

	async function loadAllSelectedTabTotals() {
		const codes = selectedTabList.value.map((item) => item.code);
		await Promise.all(codes.map((code) => loadTabTotal(code)));
		totalsLoaded.value = true;
	}

	// 定时请求工单
	const timeMessage = window.setInterval(() => {
		setTimeout(() => {
			interfaceSummary();
		}, 0);
	}, 20000);
	onBeforeRouteLeave(() => {
		window.clearInterval(timeMessage);
	});

	onMounted(() => {
		if (selectedTabList.value.length) {
			loadAllSelectedTabTotals();
		}
	});
	personalToDo();
	getWorkflowType();
</script>

<style scoped lang="scss">
	// d倒计时时间盒子

	.workOrderPagination {
		display: flex;
		justify-content: flex-end;
		margin-top: 4px;
	}

	:deep .el-table .cell {
		padding: 0 10px !important;
	}

	.workOrder {
		padding: 12px 0px 0 12px;
		margin-bottom: 10px;
		background-color: var(--theme-workbench-bg-color);

		.more-title {
			font-weight: bold;
			font-size: 18px;
			color: #000000;
			line-height: 30px;
			cursor: pointer;

			&:hover {
				color: var(--theme-color-primary) !important;
			}
		}

		.workOrderTop {
			height: 30px;
			opacity: 0.9;
			font-weight: 600;
			padding: 20px;
			background: var(--theme-workbench-bg-color);

			.arrowIconName {
				vertical-align: middle;
				display: inline-block;
				width: 164px;
				height: 16px;
				background-size: contain;
			}

			.setting {
				text-align: right;

				.el-icon {
					cursor: pointer;
				}
			}
		}

		.workOrderTable {
			padding: 20px;

			:deep .el-tabs__nav {
				width: 100% !important;
				text-align: center !important;
			}

			:deep .demo-tabs {
				.el-tabs__nav-wrap {
					.el-icon {
						color: #fff;
					}

					.el-tabs__item {
						width: 170px;
						height: 40px;
						line-height: 40px;
						text-align: center;
						color: var(--theme-workbench-title-color);
						// font-size: $app-fontsize-medium;
						font-weight: 600;
					}

					.el-tabs__active-bar {
						height: 100%;
						background: var(--theme-workbench-bg-color);
						opacity: 0.3;
						color: var(--theme-workbench-title-color);
						border-bottom: 2px solid var(--theme-workbench-icon-border-hover-color);
					}

					.is-active {
						color: var(--theme-workbench-title-color);
					}
				}

				.el-tabs__nav-wrap::after {
					display: none;
				}
			}

			:deep .el-table {
				.el-table__header-wrapper {
					th {
						// background: rgba(0, 0, 0, 0.01);
					}
				}
			}

			.workType-box {
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			// 	:deep .workType-icon {
			// 		display: inline-block;
			// 		width: 14px;
			// 	}
			// }

			// .baseSummary {
			// margin-left: 10px;
			// overflow: hidden;
			// text-overflow: ellipsis;
			// }

			// .workType {
			// 	color: $theme-workbench-title-color;

			// 	.slaBox {
			// 		display: inline-block;
			// 		width: 14px;
			// 		height: 14px;
			// 		vertical-align: middle;
			// 		border-radius: 50%;
			// 	}
			// }
		}

		.moreworkorder {
			position: absolute;
			top: -10px;
			right: 20px;
			color: #259fe9;
			font-weight: 600;
			font-size: 14px;
			cursor: pointer;
		}
	}

	.workOrderHeightMax {
		padding: 0;
		height: 100%;
		margin-bottom: 0;
		background: var(--theme-background-color);

		.workOrderAll {
			height: 100%;
			background: var(--theme-workbench-bg-color);
			position: relative;
		}

		.workOrderTop {
			height: 33px;
		}

		.workOrderTable {
			height: 80%;
			width: 100%;
			position: absolute;
			top: 0;
			margin-top: 32px;
			padding-bottom: 20px;

			:deep .demo-tabs {
				height: 100%;
				position: relative;

				.el-tabs__header {
					// height: 16%;
					height: 40px;
					// min-height: 34px;
					z-index: 99;
					margin-top: 5px;
					margin-bottom: 15px;

					.el-tabs__nav-wrap {
						height: 4rem;
						line-height: 3rem;
						border: none;

						.el-tabs__nav-scroll {
							height: 100%;
							border: none;

							.el-tabs__nav {
								height: 100%;

								.el-tabs__item {
									height: 100%;
									line-height: 4rem;
								}
							}
						}

						.el-tabs__nav-next {
							height: 100%;
							line-height: 4rem;
						}

						.el-tabs__nav-prev {
							height: 100%;
							line-height: 4rem;
						}
					}
				}

				.el-tabs__content {
					height: 100%;
					// padding-bottom: 40px;
					padding-top: 40px;
					width: 100%;
					position: absolute;
					top: 0;

					.el-tab-pane {
						overflow: auto;
						height: 100%;
					}
				}
			}
		}
	}
</style>
<style lang="scss">
	.workOrderDialog {
		.el-transfer {
			text-align: center;
		}
	}
</style>
